import React from "react";
import { colors } from "styles/colors";
import { Icon } from "components/SvgIcons";
import Button from "shared/Button";
import cloudfront from "helpers/cloudfront";

import { CollectionImage, NoImage, CollectionItemWrap, ItemRight, ItemTitle } from "./styled";
import { getImageName } from "../../helpers";

const CollectionItem = ({ collection, openCollection }) => {
  const { id, title, main_image, price } = collection;

  return (
    <CollectionItemWrap>
      <CollectionImage onClick={() => openCollection(id)}>
        {main_image ? (
          <img src={cloudfront({ href: main_image, size: "small" })} alt={getImageName(main_image)} />
        ) : (
          <NoImage>
            <Icon icon="recipes_2" />
          </NoImage>
        )}
      </CollectionImage>
      <ItemRight>
        <ItemTitle onClick={() => openCollection(id)}>{title}</ItemTitle>
        <Button
          stylType="primary"
          text={`Buy Collection $${price}`}
          color={colors.RED}
          onClick={() => openCollection(id, true)}
        />
      </ItemRight>
    </CollectionItemWrap>
  );
};

export default CollectionItem;
